import React, { useState } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { Visibility } from "@mui/icons-material";
import PendingOrdersDialog from "./PendingOrdersDialog";

const PendingOrdersCell = ({ data, type, bay }) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const hasOrders = data?.orders && data.orders.length > 0;
  const count = data?.count || 0;

  const handleViewOrders = () => {
    if (hasOrders) {
      setDialogOpen(true);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        height: "100%",
        minHeight: "52px",
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        {count}
      </Typography>
      {hasOrders && (
        <IconButton
          size="small"
          onClick={handleViewOrders}
          sx={{
            color: "#1976d2",
            "&:hover": {
              backgroundColor: "rgba(25, 118, 210, 0.04)",
            },
          }}
        >
          <Visibility fontSize="small" />
        </IconButton>
      )}

      {dialogOpen && (
        <PendingOrdersDialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          orders={data.orders}
          type={type}
          bay={bay}
        />
      )}
    </Box>
  );
};

export default PendingOrdersCell;
